import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
/**
 * @description 所有全局配置的状态管理，如无必要请勿修改
 */
import { isJson } from '@/utils/validate';
import { background, columnStyle, fixedHeader, foldSidebar, i18n, layout, logo as _logo, showFullScreen, showLanguage, showLock, showNotice, showPageTransition, showProgressBar, showRefresh, showSearch, showTabs, showTabsIcon, showTheme, showThemeSetting, tabsBarStyle, themeName, title as _title } from '@/config';
const defaultTheme = {
  layout,
  themeName,
  background,
  columnStyle,
  fixedHeader,
  showProgressBar,
  showTabs,
  tabsBarStyle,
  showTabsIcon,
  showLanguage,
  showRefresh,
  showSearch,
  showTheme,
  showNotice,
  showFullScreen,
  showThemeSetting,
  foldSidebar,
  showPageTransition,
  showLock
};
const getLocalStorage = key => {
  const value = localStorage.getItem(key);
  if (isJson(value)) {
    return JSON.parse(value);
  } else {
    return false;
  }
};
const theme = getLocalStorage('theme') || {
  ...defaultTheme
};
const {
  collapse = foldSidebar
} = getLocalStorage('collapse');
const {
  language = i18n
} = getLocalStorage('language');
const {
  lock = false
} = getLocalStorage('lock');
const {
  logo = _logo
} = getLocalStorage('logo');
const {
  title = _title
} = getLocalStorage('title');
const siteTitle = localStorage.getItem('siteTitle');
let website = null;
try {
  const rawWebsite = localStorage.getItem('website');
  website = rawWebsite ? JSON.parse(rawWebsite) : null;
} catch (e) {
  website = null;
}
export const useSettingsStore = defineStore('settings', {
  state: () => ({
    theme,
    device: 'desktop',
    collapse,
    language,
    lock,
    logo,
    title,
    echartsGraphic1: ['#3ED572', '#399efd'],
    echartsGraphic2: ['#399efd', '#8cc8ff'],
    siteTitle,
    website
  }),
  getters: {
    getTheme: state => state.theme,
    getDevice: state => state.device,
    getCollapse: state => state.collapse,
    getLanguage: state => state.language,
    getLock: state => state.lock,
    getLogo: state => state.logo,
    getTitle: state => {
      const name = state.website?.managementName;
      return typeof name === 'string' && name.trim() || '订货系统';
    },
    getSiteTitle: state => state.siteTitle,
    getWebsite: state => state.website
  },
  actions: {
    updateState(obj) {
      Object.keys(obj).forEach(key => {
        this[key] = obj[key];
        localStorage.setItem(key, typeof obj[key] == 'string' ? `{"${key}":"${obj[key]}"}` : `{"${key}":${obj[key]}}`);
      });
    },
    saveTheme() {
      localStorage.setItem('theme', JSON.stringify(this.theme));
    },
    resetTheme() {
      this.theme = {
        ...defaultTheme
      };
      localStorage.removeItem('theme');
    },
    toggleCollapse() {
      this.collapse = !this.collapse;
      localStorage.setItem('collapse', `{"collapse":${this.collapse}}`);
    },
    toggleDevice(device) {
      this.updateState({
        device
      });
    },
    openSideBar() {
      this.updateState({
        collapse: false
      });
    },
    foldSideBar() {
      this.updateState({
        collapse: true
      });
    },
    changeLanguage(language) {
      this.updateState({
        language
      });
    },
    handleLock() {
      this.updateState({
        lock: true
      });
    },
    handleUnLock() {
      this.updateState({
        lock: false
      });
    },
    changeLogo: logo => {
      this.updateState({
        logo
      });
    },
    changeTitle: title => {
      this.updateState({
        title
      });
    },
    changeSitTitle: siteTitle => {
      localStorage.setItem('siteTitle', siteTitle);
    },
    changeWebsite(website) {
      this.website = website;
      localStorage.setItem('website', JSON.stringify(website));
    }
  }
});